/* global axios */
import ApiClient from './ApiClient';

class TicketsApi extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true });
  }

  list(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, data);
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  reorder(ticketIds) {
    return axios.patch(`${this.url}/reorder`, { ticket_ids: ticketIds });
  }
}

export default new TicketsApi();
